// extracted by mini-css-extract-plugin
export default {"catalogManagement":"CatalogManagement_catalogManagement__BadtE","categoriesProducts":"CatalogManagement_categoriesProducts__t8gbM"};